import {
  ActiveInactiveStatus,
  ApiListRequest,
  ApiListResponse,
  MembershipBean,
  MembershipDurationType,
  MembershipType,
} from "@gymflow/types";
import {
  infiniteQueryOptions,
  QueryKey,
  queryOptions,
} from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["hostedApiMembership"] as QueryKey,
  id: (id?: unknown) => [...keys.all(), "id", id] as QueryKey,
  list: (filter: unknown) => [...keys.all(), "list", filter] as QueryKey,
};

export const hostedApiMembership = {
  keys,
  queries: {
    id: (id: number | undefined) =>
      queryOptions({
        queryKey: keys.id(id),
        queryFn: async () => {
          return (await api.get<MembershipBean>(`/hosted/membership/${id}`))
            .data;
        },
        enabled: !!id,
      }),
  },
  infiniteQueries: {
    list: (
      params: {
        status?: ActiveInactiveStatus;
        id?: number[];
        type?: MembershipType;
        durationType?: MembershipDurationType[];
        isTrial?: boolean;
      } & ApiListRequest,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.get<ApiListResponse<MembershipBean>>(
              `/hosted/membership`,
              {
                params: { ...params, page: pageParam },
              },
            )
          ).data;
        },
        ...numberPagination,
      }),
  },
  mutations: {},
};
